import { Reveal } from "./Reveal";
import { PARCOURS } from "../../data/content";

export const Process = () => {
  return (
    <section
      id="parcours"
      data-testid="process-section"
      className="relative bg-pblv-bg py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-end">
          <div className="max-w-2xl">
            <Reveal>
              <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-pblv-mauve">
                Comment ça marche
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-pblv-ink md:text-6xl">
                Votre T'POZ,
                <br />
                <span className="italic">en quatre pas.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-lg leading-relaxed text-pblv-inksoft">
              Un accompagnement simple et humain, du premier contact jusqu'à
              votre séjour, à votre rythme.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PARCOURS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.1} y={36}>
              <div
                data-testid={`process-step-${step.n}`}
                className="group relative flex h-full flex-col rounded-[1.75rem] border border-pblv-ink/10 bg-white p-8 transition-all duration-500 hover:-translate-y-2 hover:border-pblv-mauve/30 hover:shadow-[0_16px_40px_rgba(45,40,48,0.08)]"
              >
                <span className="font-serif text-6xl font-medium text-pblv-bg2 transition-colors duration-500 group-hover:text-pblv-rose/60">
                  {step.n}
                </span>
                <h3 className="mt-4 font-serif text-2xl font-medium text-pblv-ink">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-pblv-inksoft">
                  {step.body}
                </p>
                <span className="mt-6 h-1 w-10 rounded-full bg-pblv-sage/40 transition-all duration-500 group-hover:w-16 group-hover:bg-pblv-mauve" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
